<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>跟单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">

      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityId" placeholder="请选择城市" clearable filterable @change="cityChange">
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.city"
              :value="item.cityId"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="驿站">
          <el-select v-model="listQuery.postStationId" clearable placeholder="请选择驿站" filterable
            @change="postStationChange">
            <el-option v-for="(item, index) in postStationList" :key="index" :label="item.postStation"
              :value="item.postStationId">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="服务站">
          <el-select v-model="listQuery.station" clearable placeholder="请选择服务站" filterable @change="change">
            <template v-for="(item, index) in stationList">
              <el-option :key="index" v-if="item.cityId == listQuery.cityId" :label="item.station"
                :value="item.stationId">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="服务者工号">
          <el-input v-model="listQuery.workerNo" clearable placeholder="请输入服务者工号"></el-input>
        </el-form-item>
        <el-form-item label="服务者">
          <el-input v-model="listQuery.workerName" placeholder="请输入服务者姓名"></el-input>
        </el-form-item>
        <!-- <el-form-item label="跟单师傅">
          <el-input v-model="listQuery.chiefmasterName" placeholder="请输入跟单师傅姓名"></el-input>
        </el-form-item>
        <el-form-item label="跟单师傅手机号">
          <el-input v-model="listQuery.chiefmasterTel" placeholder="请输入跟单师傅手机号"></el-input>
        </el-form-item> -->
        <el-form-item label="审核人">
          <el-input v-model="listQuery.judgerName" placeholder="请输入审核人姓名"></el-input>
        </el-form-item>
        <el-form-item label="跟单类型">
          <el-select v-model="listQuery.onJobType" clearable placeholder="请选择跟单类型" filterable>
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟单结果">
          <el-select v-model="listQuery.ojtResult" clearable placeholder="请选择跟单结果" filterable>
            <el-option v-for="(item, index) in resultList" :key="index" :label="item.name"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟单状态">
          <el-select v-model="listQuery.ojtState" clearable placeholder="请选择跟单状态" filterable>
            <el-option v-for="(item, index) in statusList" :key="index" :label="item.name"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟单数量">
          <el-input v-model="listQuery.onJobNum" placeholder="请输入跟单数量"></el-input>
        </el-form-item>
        <el-button icon="el-icon-search" type="primary" plan @click="search">查询</el-button>
        <el-button icon="el-icon-plus" type="primary" plan @click="alertApplyOnJob" v-per="'shenqinggendan'">申请跟单
        </el-button>
      </el-form>

      <el-table :data="list" border style="width: 100%" class="table">
        <el-table-column label="城市" prop="cityName">
          <template slot-scope="scope">
            <span>{{ getCityName(scope.row.cityId) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="驿站" prop="postStationName">
          <template slot-scope="scope">
            <span>{{ getPostStation(scope.row.postStationId) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="服务站" prop="stationName">
          <template slot-scope="scope">
            <span>{{ getStation(scope.row.station) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商家编号" prop="workerNo"></el-table-column>
        <el-table-column label="商家姓名" prop="workerName"></el-table-column>
        <el-table-column label="商家手机号" prop="workerTel"></el-table-column>
        <el-table-column label="综合星级" prop="scoreLevel"></el-table-column>
        <!-- <el-table-column label="跟单师傅" prop="chiefmasterName"></el-table-column>
        <el-table-column label="跟单师傅手机号" prop="chiefmasterTel"></el-table-column> -->
        <el-table-column label="审核人" prop="judgerName"></el-table-column>
        <el-table-column label="跟单类型" prop="onJobType">
          <template slot-scope="scope">
            <span>{{typeList.find(a => a.typeId == scope.row.onJobType).name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="跟单结果" prop="ojtResult">
          <template slot-scope="scope">
            <span>{{ scope.row.ojtResult === "" ? "" : scope.row.ojtResult == true ? "通过" : "不通过" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="跟单状态" prop="ojtState">
          <template slot-scope="scope">
            <span>{{statusList.find(a => a.value == scope.row.ojtState).name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="跟单数量" prop="onJobNum"></el-table-column>
        <el-table-column label="操作" width="130" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button round size="mini" @click="alertDetail(scope.row)">详情</el-button>
            <el-button round size="mini" v-if="scope.row.canAddSubItem" @click="alterAddSubRecord(scope.row)"
              v-per="'tianjiagendanxiang'">
              添加子跟单项
            </el-button>
            <el-button round size="mini" v-if="scope.row.canShowFinish" @click="alterFinshOnJob(scope.row)"
              v-per="'wanchenggendan'">完成跟单
            </el-button>
            <el-button round size="mini" v-if="scope.row.ojtState <= 1" @click="cancelOnjob(scope.row)"
              v-per="'quxiaogendan'">取消跟单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize"
        @pagination="queryList(currentPage, pageSize)" />
    </el-card>


    <el-dialog :visible.sync="showApplyOnJob" title="申请跟单" width="80%">
      <el-form :inline="true" size="small" v-model="applyOnJobForm" label-width="150px" label-position="right">
        <el-form-item label="商家编号">
          <el-select v-model="applyOnJobForm.workerNo" clearable placeholder="请选择商家(支持编号/姓名/手机号搜索)" filterable remote
            :remote-method="searchWorkers" :loading="workerSearchLoading" @change="getWorkerInfo">
            <el-option v-for="(item, index) in filteredWorkerList" :key="index"
              :label="item.workerNo + '(' + item.workerName + '-' + item.workerTel + ')'" :value="item.workerNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家姓名">
          <el-input v-model="applyOnJobForm.workerName" placeholder="请输入商家姓名"></el-input>
        </el-form-item>
        <el-form-item label="商家手机号">
          <el-input v-model="applyOnJobForm.workerTel" placeholder="请输入商家手机号"></el-input>
        </el-form-item>
        <el-form-item label="城市">
          <el-input v-model="applyOnJobForm.cityName" clearable placeholder="请输入城市"></el-input>
        </el-form-item>
        <!-- <el-form-item label="驿站">
          <el-input v-model="applyOnJobForm.postStationName" clearable placeholder="请输入驿站"></el-input>
        </el-form-item> -->
        <el-form-item label="服务站">
          <el-input v-model="applyOnJobForm.stationName" clearable placeholder="请输入服务站"></el-input>
        </el-form-item>
        <el-form-item label="跟单是否有薪">
          <el-select value="1" clearable placeholder="请选择跟单是否有薪" v-model="applyOnJobForm.isDocumentary">
            <el-option label="无薪" value="1"></el-option>
            <el-option label="有薪" value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="负责师傅">
          <el-select v-model="applyOnJobForm.chiefmasterId" clearable placeholder="请选择负责师傅" filterable
                    @change="getChiefmasterInfo">
            <el-option v-for="(item,index) in masterList" :key="index" :label="item.workerName"
                    :value="item.workerNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责师傅电话">
          <el-input v-model="applyOnJobForm.chiefmasterTel" placeholder="请输入负责师傅电话"></el-input>
        </el-form-item> -->
        <el-form-item label="跟单类型">
          <el-select v-model="applyOnJobForm.onJobType" clearable placeholder="请选择跟单类型" filterable>
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.typeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟单数量">
          <el-input-number v-model="applyOnJobForm.onJobNum" placeholder="请输入跟单数量" :max=10 :min=1></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="applyOnJobForm.remark" placeholder="请输入备注" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align:center; margin: auto">
        <el-button type="primary" @click="applyOnJob">提交</el-button>
        <el-button type="primary" @click="showApplyOnJob = false">取消</el-button>
      </div>

    </el-dialog>

    <el-dialog :visible.sync="showDetail">
      <el-descriptions v-model="detailForm" border :column="3" class="margin-top" title="详情">
        <el-descriptions-item label="商家编号">{{ detailForm.workerNo }}</el-descriptions-item>
        <el-descriptions-item label="商家姓名">{{
          detailForm.workerName
        }}
        </el-descriptions-item>
        <el-descriptions-item label="商家手机号">{{
          detailForm.workerTel
        }}
        </el-descriptions-item>
        <el-descriptions-item label="跟单是否有薪">
          {{ detailForm.isDocumentary === 2 ? "有薪" : detailForm.isDocumentary === 1 ? "无薪" : "" }}
        </el-descriptions-item>
        <el-descriptions-item label="申请跟单时间">
          {{ detailForm.applyTime | dateFormat("yyyy-MM-DD HH:mm:ss") }}
        </el-descriptions-item>
        <el-descriptions-item label="首次跟单时间">
          {{ detailForm.firstTime | dateFormat("yyyy-MM-DD HH:mm:ss") }}
        </el-descriptions-item>
        <el-descriptions-item label="跟单分数">
          {{ detailForm.ojtScore }}
        </el-descriptions-item>
        <el-descriptions-item label="跟单结果">
          {{ detailForm.ojtResult === "" ? " " : detailForm.ojtResult === true ? "通过" : "不通过" }}
        </el-descriptions-item>
        <el-descriptions-item label="跟单不通过原因">
          {{ detailForm.nopassReason }}
        </el-descriptions-item>
        <el-descriptions-item label="跟单评语">
          {{ detailForm.ojtComment }}
        </el-descriptions-item>
        <el-descriptions-item label="审核人">
          {{ detailForm.judgerName }}
        </el-descriptions-item>
        <el-descriptions-item label="评价时间">
          {{ detailForm.judgeTime | dateFormat("yyyy-MM-DD HH:mm:ss") }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ detailForm.remark }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <span class="el-descriptions__title">跟单履历</span>
      <el-table :data="subItems" class="table" style="width: 100%" ref="el-table">
        <!--        <el-table-column type="index" label="序号"></el-table-column>-->
        <el-table-column label="盒马工单编号" prop="hmTradeNo"></el-table-column>
        <el-table-column label="跟单状态" prop="ojtState">
          <template slot-scope="scope">
            <span>{{statusList.find(a => a.value == scope.row.ojtState).name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="带单师傅编号" prop="masterWorkerNo"></el-table-column>
        <el-table-column label="带单师傅姓名" prop="masterWorkerName"></el-table-column>
        <el-table-column label="开始跟单时间" prop="startOnjobTime" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.startOnjobTime | dateFormat("yyyy-MM-DD HH:mm:ss") }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束跟单时间" prop="finshOnjobTime" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.finshOnjobTime | dateFormat("yyyy-MM-DD HH:mm:ss") }}</span>
          </template>
        </el-table-column>
        <el-table-column label="本次跟单评语" prop="ojtrComment"></el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
        <el-table-column label="操作" width="150" fixed="left">
          <template slot-scope="scope">
            <center>
              <el-button v-if="scope.row.ojtState === 0" round size="mini"
                @click="startToOnJob(scope.row, scope.$index)" type="primary">开始跟单
              </el-button>
              <el-button round size="mini" v-if="scope.row.ojtState !== 2" @click="deleteSubItem(scope.row.id)"
                type="danger">删除
              </el-button>
              <el-button type="success" round size="mini" v-if="scope.row.ojtState === 1"
                @click="alterSubComment(scope.row.id)">完成子跟单
              </el-button>
            </center>
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="showSubAdd" width="1200px" title="添加子跟单项">
      <el-form :inline="true" size="small" v-model="mapQuery">
        <el-form-item label="师傅姓名">
          <el-select style="width:300px" v-model="mapQuery.workerName" filterable clearable>
            <el-option v-for="(item, index) in workerNameList" :key="index"
              :label="item.workerName + ' ' + item.workerTel" :value="item.workerName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker style="width:300px" v-model="mapQuery.day" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期"></el-date-picker>
        </el-form-item>

        <el-button icon="el-icon-search" type="primary" plan @click="searchMap">查询</el-button>
      </el-form>

      <el-row>
        <el-col :span="12">
          <el-table :data="tradeOrderList" border style="width: 100%;height: 460px" max-height="460px" class="table">
            <el-table-column label="工单编号" prop="bookTradeNo"></el-table-column>
            <el-table-column label="服务者姓名" prop="workerName">
            </el-table-column>
            <el-table-column label="服务者手机号" prop="servantPhone">
            </el-table-column>
            <el-table-column label="服务时间" prop="beginTime"></el-table-column>
            <el-table-column label="地址" prop="addrName"></el-table-column>
            <el-table-column label="操作" width="130" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button round size="mini" @click="addHmTradeNos(scope, scope.row)" :disabled='scope.row.isEdit'>添加
                  {{ isAdd }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <div id="mapWrapper">

          </div>
        </el-col>
      </el-row>

      <p style="color:red;margin-bottom:10px;font-size:16px;">请点击地图上的标记点添加跟单项</p>
      <el-form size="small" :v-model="subAddForm" label-width="150px" class="order-form" label-position="left">
        <el-form-item v-for="(a, index) in subAddForm.hmTradeNos" :label="'盒马工单' + (index + 1)" :key="(index + 1)">
          <!-- <el-select v-model="a.hmTradeNo" placeholder="请选择盒马工单" @change="setNewValue">
            <el-option v-for="item in masterOrders" :key="item.bookTradeNo"
                      :label="item.beginTime+'------'+item.itemName"
                      :value="item.bookTradeNo">
            </el-option>
          </el-select> -->
          <el-input v-model="a.bookTradeNo" placeholder="请点击地图上的标记点" disabled>

          </el-input>
          <span style="margin:0 20px;"><b>地址:</b>{{
            a.addrName
          }}</span>
          <span><b>时间:</b>{{ a.beginTime }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span><b>师傅编号:</b>{{ a.workerNo }}</span><br />
          <span style="margin-left: 145px"><b>师傅姓名:</b>{{ a.workerName
          }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span><b>服务项:</b>{{ a.itemName }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <el-button @click.prevent="removeTemp(a)">删除</el-button>
        </el-form-item>
        <!-- 输入带徒费 ，不可超过200元-->
        <el-form-item label="带徒费">
          <el-input-number v-model="subAddForm.masterMoney" :min="0" :max="200" placeholder="请输入带徒费"   style="width:300px"></el-input-number>
          <span style="margin-left: 10px;color:red;">只能输入0-200之间的数</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="subAddForm.remark" placeholder="请输入备注" type="textarea" style="width:500px"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align:center; margin: auto">
        <!-- <el-button @click="addSubOnJob" type="primary">添加跟单项</el-button> -->
        <el-button type="primary" @click="addSubRecord">提交</el-button>
        <el-button type="primary" @click="showSubAdd = false">取消</el-button>
      </div>

    </el-dialog>


    <el-dialog :visible.sync="showSubComment" title="完成子跟单" width="20%" ref="subCommentForm">
      <el-form :inline="true" size="small" v-model="subCommentForm" label-width="80px" label-position="left"
        title="完成子跟单并添加评语" :rules="finshSubFormRule" :ref="subCommentForm">
        <el-form-item label="评语" prop="comment">
          <el-input v-model="subCommentForm.comment" placeholder="请输入评语" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="addSubComment">提交</el-button>
      <el-button type="primary" @click="showSubComment = false">取消</el-button>
    </el-dialog>

    <el-dialog :visible.sync="showFinshOjb" title="完成跟单">
      <el-form :inline="true" size="small" v-model="finshOjbForm" label-width="150px" label-position="left">
        <el-form-item label="跟单结果">
          <el-select v-model="finshOjbForm.ojtResult" placeholder="请选择跟单结果">
            <el-option label="通过" value="1"></el-option>
            <el-option label="未通过" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟单分数">
          <el-input-number v-model="finshOjbForm.ojtScore" :min=1 :max=100 :step=1></el-input-number>
        </el-form-item>
        <el-form-item label="不通过原因" v-if="finshOjbForm.ojtResult == 0">
          <el-select v-model="finshOjbForm.nopassReason" placeholder="请选择不通过原因">
            <el-option v-for="item in noPassReasonList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评语">
          <el-input v-model="finshOjbForm.ojtComment" placeholder="请输入评语" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align:center; margin: auto">
        <el-button type="primary" @click="finshOjb" v-per="'wanchengzigendan'">提交</el-button>
        <el-button type="primary" @click="showFinshOjb = false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import service from "@/script/api/workercrmapi";
import moment from "moment";

export default {
  components: { Pagination },
  data() {
    return {
      map: "",
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        workerNo: ""
      },
      list: [],
      cityList: [],
      allPostionList: [],
      allStationList: [],
      postStationList: [],
      stationList: [],
      resultList: [
        { name: "通过", value: "1" },
        { name: "不通过", value: "0" }
      ],
      typeList: [
        { name: "赋能跟单", typeId: "1" },
        { name: "治理跟单", typeId: "2" }
      ],
      statusList: [
        { name: "待安排", value: "0" },
        { name: "跟单中", value: "1" },
        { name: "跟单完成", value: "2" },
        { name: "取消", value: "3" }
      ],
      noPassReasonList: [
        { name: "跟单重修", value: "1" },
        { name: "培训/课程重修", value: "2" },
        { name: "淘汰", value: "3" },
        { name: "更换驿站", value: "4" },
        { name: "其他", value: "5" }
      ],
      showApplyOnJob: false,
      handleVisible: false,
      applyOnJobForm: {
        workerName: "",
        workerTel: "",
        cityId: "",
        station: "",
        postStationId: "",
        typeId: "",
        workerId: "",
        remark: "",
        onJobNum: null
      },
      showDetail: false,
      detailForm: {},
      subItems: [],
      workerList: [],
      masterList: [],
      showSubAdd: false,
      subAddForm: {},
      masterOrders: [{ bookTradeNo: null, beginTime: null, itemName: "" }],
      showSubItemDetail: false,
      subItemDetailForm: {},
      showSubComment: false,
      subCommentForm: {},
      showFinshOjb: false,
      finshOjbForm: { ojtScore: null, ojtState: null },
      maxSubLength: 0,
      finshSubFormRule: {
        comment: [
          { required: true, message: "请输入评语", trigger: "blur" }
        ]
      },
      mapQuery: {
        day: "",
        workerNo: "",
        workerName: ""
      },
      workerNameList: [],
      tradeOrderList: [],
      isAdd: "",
      removeMarker: [],
      // 新增: 用于搜索功能的数据
      filteredWorkerList: [],
      workerSearchLoading: false,
      searchTimer: null
    };
  },
  filters: {
    dateFormat(val, format) {
      if (val === "") {
        return "";
      }
      if (null == format) {
        return moment(val).format("YYYY-MM-DD");
      }
      return moment(val).format(format);
    }
  },
  watch: {
    $route(to) {
      if (to.name === "documentary") {
        this.syncWorkerNo(to.query.wokrerNo);
      }
    }
  },
  created() {
    this.queryAllPostStation();
    this.loadOnJobWorkerList();
  },

  mounted() {
    // 监听localStorage变化事件
    window.addEventListener('storage', this.handleStorageChange);

    // 检查是否有待处理的workerNo
    const storedWorkerNo = localStorage.getItem('documentaryWorkerNo');
    const routeWorkerNo = this.$route.query.wokrerNo;
    this.syncWorkerNo(routeWorkerNo || storedWorkerNo, false);
    if (storedWorkerNo) {
      localStorage.removeItem('documentaryWorkerNo');
    }

    this.queryList();
  },

  beforeDestroy() {
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    // 移除事件监听
    window.removeEventListener('storage', this.handleStorageChange);
  },

  methods: {
    // 监听localStorage变化
    handleStorageChange(event) {
      if (event.key === 'documentaryWorkerNo' && event.newValue) {
        this.syncWorkerNo(event.newValue);
        localStorage.removeItem('documentaryWorkerNo');
      }
    },
    syncWorkerNo(workerNo, refreshList = true) {
      if (workerNo == null || workerNo === '') {
        return;
      }
      const changed = this.listQuery.workerNo != workerNo;
      this.listQuery.workerNo = workerNo;
      if (refreshList && changed) {
        this.currentPage = 1;
        this.queryList(this.currentPage, this.pageSize);
      }
    },

    mapInit() {
      let _this = this;
      _this.map = new AMap.Map("mapWrapper", {
        resizeEnable: true,
        // center: [116.397428, 39.90923],
        zoom: 16
        // keyboardEnable: false,
      });
      _this.map.on("complete", function () {
        console.log("map complete");
      });


      this.tradeOrderList = [];
      this.map.clearMap();  // 清除地图覆盖物
      //this.searchMap();


    },
    pointSelect(e, point) {
      console.log(e);
      console.log(point);
      if (this.subAddForm.hmTradeNos.length >= this.maxSubLength) {
        this.$message.error("超过可跟单最大数量");
        return;
      }
      let obj = point;
      obj.hmTradeNo = point.bookTradeNo;
      this.subAddForm.hmTradeNos.push(obj);

      //禁用按钮
      let number2 = this.tradeOrderList.indexOf(point);
      this.$set(this.tradeOrderList[number2], "isEdit", true);
      this.$forceUpdate();
      this.updateContent(point.position);
    },
    searchMap() {
      if (this.mapQuery.workerName == "") {
        this.$message.error("请先选择师傅名称！");
        return;
      }
      if (null == this.mapQuery.day || this.mapQuery.day === "" || this.mapQuery.day === undefined) {
        this.mapQuery.day = "";
      }
      service.$ajaxGetOnJobList(
        {
          day: this.mapQuery.day,
          workerNo: this.mapQuery.workerNo,
          workerName: this.mapQuery.workerName
        }
      ).then(res => {
        if (res.data.errno == 0) {
          console.log(res);
          let list = res.data.data;
          this.tradeOrderList = list;
          this.renderMap(list);
        } else {
          this.tradeOrderList = [];
          this.map.clearMap();
        }
      }).catch(res => {
        this.tradeOrderList = [];
        this.map.clearMap();
      });


    },
    renderMap(points) {
      var _this = this;
      var markers = [];
      var positions = points;

      // 添加一些分布不均的点到地图上,地图上添加三个点标记，作为参照
      positions.forEach(function (point) {
        let lnglat = point.position.split(",");
        //  console.log(lnglat);
        let marker = new AMap.Marker({
          map: _this.map,
          position: [lnglat[0], lnglat[1]],
          offset: new AMap.Pixel(-13, -30)
          // content:'1'
        });
        marker.on("click", function (e) {
          _this.pointSelect(e, point);
        });

        markers.push(marker);
      });
      this.markers = markers;
      //this.marker=marker;

      this.map.setFitView(null, false, [150, 60, 100, 60]);
      var newCenter = this.map.getCenter();
    },

    setNewValue(a) {
      this.$forceUpdate();
    },
    removeTemp(temp) {
      if (this.subAddForm.hmTradeNos.length - 1 <= 0) {
        this.$message.error("至少需要一条子跟单");
        return;
      }
      let number = this.subAddForm.hmTradeNos.indexOf(temp);
      if (number !== -1) {
        this.subAddForm.hmTradeNos.splice(number, 1);
      }

      //解除按钮
      let number2 = this.tradeOrderList.indexOf(temp);
      this.$set(this.tradeOrderList[number2], "isEdit", false);

      this.$forceUpdate();
      //恢复样式
      this.defaultMarker(temp.position);

    },
    addSubOnJob() {
      //检查数量是否超过最大
      if (this.subAddForm.hmTradeNos.length >= this.maxSubLength) {
        this.$message.error("超过可跟单最大数量");
        return;
      }
      this.subAddForm.hmTradeNos.push({ hmTradeNo: "", key: Date.now() });
      this.$forceUpdate();
      console.log("this.subAddForm", this.subAddForm);
    },
    loadMaster() {
      service.$ajaxMasterPageList().then(res => {
        this.masterList = res.data.data;
      });
    },
    getCityName(cityId) {
      if (cityId == null || cityId === "") {
        return;
      }
      let a = this.cityList.find(item => item.cityId == cityId);
      if (null == a) {
        return "";
      }
      return a.city;
    },
    getPostStation(id) {
      let a = this.allPostionList.find(item => item.postStationId == id);
      if (a == null) {
        return "";
      }
      return a.postStation;
    },
    getStation(id) {
      let a = this.allStationList.find(item => item.stationId == id);
      if (a == null) {
        return "";
      }
      return a.station;
    },
    deleteNullRelation(param) {
      let newParam = { ...param };
      for (let key in newParam) {
        if (newParam[key] === null || newParam[key] === "" || newParam[key] === "" || newParam[key] === undefined) {
          delete newParam[key];
        }
      }
      return newParam;
    },
    queryAllPostStation() {
      service.$axiosGetAllPostStation().then(res => {
        console.log(res.data.data);
        this.cityList = res.data.data.city;
        this.allPostionList = res.data.data.postStation;
        this.allStationList = res.data.data.station;
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      });
    },
    search() {
      this.queryList();
    },
    queryList(page, size) {
      let params = {
        page: page || 1,
        size: size || 10,
        ...this.listQuery
      };
      if (null == this.listQuery.ojtState || this.listQuery.ojtState === "" || this.listQuery.ojtState === undefined) {
        params.ojtState = '';
      }
      service.$ajaxemCourseFollowGetPageList(this.deleteNullRelation(params)).then(res => {
        console.log(res.data.data);
        this.list = res.data.data.list;
        this.total = res.data.data.total;
        this.syncDetailFromList(this.list);
      });
    },
    syncDetailFromList(list) {
      if (!this.showDetail || this.detailForm.id == null) {
        return;
      }
      const detail = list.find(item => item.id == this.detailForm.id);
      if (detail) {
        this.detailForm = detail;
        this.subItems = detail.subItems ? detail.subItems : [];
      }
    },
    cityChange() {
      this.listQuery.postStationId = "";
      if (this.listQuery.cityId !== null && this.listQuery.cityId !== "") {
        this.postStationList = [];
        let cityId = this.listQuery.cityId;
        console.log("cityId", cityId);
        this.allPostionList.forEach(item => {
          console.log("item.id", item.cityId);
          if (item.cityId == cityId) {
            this.postStationList.push(item);
          }
        });
        this.stationList = [];
        this.allStationList.forEach(item => {
          if (item.cityId == cityId) {
            this.stationList.push(item);
          }
        });
      } else {
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      }
    },
    postStationChange() {
      this.listQuery.stationId = "";
      if (this.listQuery.postStationId != null && this.listQuery.postStationId !== "") {
        this.stationList = [];
        let postStationId = this.listQuery.postStationId;
        this.allStationList.filter(a => {
          if (a.postStationId == postStationId) {
            this.stationList.push(a);
          }
        });
      } else {
        this.stationList = this.allStationList.slice();
      }
    },
    change(id) {
      this.$forceUpdate();
    },
    async alertApplyOnJob() {
      this.applyOnJobForm = {
        onJobNum: 4,
        onJobType: "1",
        isDocumentary: "1"
      };
      // 重置搜索状态

      if (this.listQuery.workerNo) {
        await this.loadOnJobWorkerList();
        this.getWorkerInfo(this.listQuery.workerNo);
        if (this.applyOnJobForm.workerName) {
          this.applyOnJobForm.workerNo = this.listQuery.workerNo;
        }
      }
      this.filteredWorkerList = this.workerList;
      this.showApplyOnJob = true;


    },
    alertDetail(detail) {
      this.showDetail = true;
      this.detailForm = detail ? detail : {};
      this.subItems = detail.subItems ? detail.subItems : [];
    },
    loadOnJobWorkerList() {
      return service.$ajaxCanFollowGetPageList().then(res => {
        console.log(res.data.data);
        this.workerList = res.data.data;
        // 初始化时显示所有数据
        this.filteredWorkerList = res.data.data;
        return this.workerList;
      });
    },
    // 新增: 商家搜索方法
    searchWorkers(query) {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.workerSearchLoading = true;

      // 防抖处理，避免频繁搜索
      this.searchTimer = setTimeout(() => {
        if (!query || query.trim() === '') {
          // 如果搜索内容为空，显示所有数据
          this.filteredWorkerList = this.workerList;
        } else {
          // 支持按编号或姓名搜索
          const searchText = query.toLowerCase();
          this.filteredWorkerList = this.workerList.filter(worker => {
            const workerNo = (worker.workerNo || '').toLowerCase();
            const workerName = (worker.workerName || '').toLowerCase();
            const workerTel = (worker.workerTel || '').toLowerCase();

            return workerNo.includes(searchText) ||
              workerName.includes(searchText) ||
              workerTel.includes(searchText);
          });
        }
        this.workerSearchLoading = false;
      }, 300); // 300ms防抖
    },
    getWorkerInfo(id) {
      if (id == null || id == undefined || id == '') {
        //清空applyOnJobForm
        this.applyOnJobForm = {
          onJobNum: 4,
          onJobType: "1",
          isDocumentary: "1"
        };
        return;
      }
      console.log("this.id =" + id);
      let thisWorker = this.workerList.find(a => a.workerNo == id);
      if (thisWorker == null || thisWorker == undefined || thisWorker == '') {
        return;
      }
      console.log("thisWorker =" + JSON.stringify(thisWorker));
      this.applyOnJobForm.workerName = thisWorker.workerName;
      this.applyOnJobForm.workerTel = thisWorker.workerTel;
      this.applyOnJobForm.cityId = thisWorker.cityId;
      this.applyOnJobForm.cityName = this.getCityName(thisWorker.cityId);
      this.applyOnJobForm.postStationId = thisWorker.postStationId;
      this.applyOnJobForm.postStationName = this.getPostStation(thisWorker.postStationId);
      this.applyOnJobForm.station = thisWorker.stationId;
      this.applyOnJobForm.stationName = this.getStation(thisWorker.stationId);
    },
    getChiefmasterInfo(id) {
      let master = this.masterList.find(a => a.workerNo == id);
      this.applyOnJobForm.chiefmasterId = id;
      this.applyOnJobForm.chiefmasterName = master.workerName;
      this.applyOnJobForm.chiefmasterTel = master.workerTel;
    },
    applyOnJob() {
      service.$ajaxStartOnJob(this.deleteNullRelation(this.applyOnJobForm)).then(res => {
        console.log(res.data.data);
        this.showApplyOnJob = false;
        this.queryList();
      });
    },
    alterAddSubRecord(rowDetail) {
      console.log("rowDetail", JSON.stringify(rowDetail));
      this.showSubAdd = true;
      this.mapQuery.workerNo = rowDetail.workerNo;
      this.subAddForm = {};
      this.subAddForm.masterWorkerNo = rowDetail.chiefmasterId;
      this.subAddForm.masterWorkerName = rowDetail.chiefmasterName;
      this.subAddForm.ojbId = rowDetail.id;
      this.subAddForm.hmTradeNos = [];
      // this.subAddForm.hmTradeNos = [{bookTradeNo: '123', }];
      // this.subAddForm.hmTradeNos = [{hmTradeNo: '', key: Date.now()}];
      this.maxSubLength = rowDetail.onJobNum - rowDetail.subItems.length;
      // this.queryMasterOrders(rowDetail.chiefmasterTel);
      //  this.mapInit();
      this.getWorkerNameList(rowDetail.workerNo);
      setTimeout(() => {
        this.mapInit();
      }, 500);

    },
    queryMasterOrders(tel) {
      let param = {
        workerTel: tel
      };
      service.$ajaxMasterOrderList(param).then(res => {
        console.log(res.data.data);
        this.masterOrders = res.data.data;
      });
    },
    addSubRecord() {
      //检查是否有选中相同的盒马工单号，有则提示
      let hmTradeNos = this.subAddForm.hmTradeNos;
      let hmTradeNoArr = [];
      hmTradeNos.forEach(item => {
        // hmTradeNoArr.push(item.hmTradeNo);
        hmTradeNoArr.push(item.bookTradeNo);
      });
      if (hmTradeNos.filter(a => a.bookTradeNo.length === 0).length > 0) {
        this.$message.error("请选择盒马工单号");
        return;
      }
      let repeatHmTradeNo = hmTradeNoArr.some((item, index) => {
        return hmTradeNoArr.indexOf(item) != index;
      }).toString();
      if (repeatHmTradeNo == "true") {
        this.$message.error("盒马工单号不能重复！");
        return;
      }
      //提交子跟单信息
      service.$ajaxAddOnJobItem(this.subAddForm).then(res => {
        console.log(res.data.data);
        this.showSubAdd = false;
        this.queryList();
      });
    },
    startToOnJob(subItem, index) {
      //开始跟单
      let param = {
        onJobId: subItem.ojtId,
        subOnJobId: subItem.id
      };
      service.$ajaxStartOnJobItem(param).then(res => {
        this.$nextTick(function () {
          let x = this.subItems[index].ojtState = 1;
          this.$set(this.subItems[index], x, 1);
        });
      });
    },

    deleteSubItem(id) {
      //确认是否删除子跟单
      this.$confirm("确认删除子跟单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        service.$ajaxDeleteOnJobItem({ subOnJobId: id }).then(res => {
          this.queryList(this.currentPage, this.pageSize);
        });
      });
    },
    alterSubComment(id) {
      this.showSubComment = true;
      this.subCommentForm = {};
      this.subCommentForm.subOnJobId = id;
    },
    addSubComment() {
      if (null == this.subCommentForm.comment || this.subCommentForm.comment === "") {
        this.$message.error("请输入评语！");
        return;
      }
      service.$ajaxAddOnJobItemComment(this.subCommentForm).then(res => {
        this.showSubComment = false;
        this.queryList(this.currentPage, this.pageSize);
      });
    },
    alterFinshOnJob(row) {
      this.showFinshOjb = true;
      this.finshOjbForm = {};
      this.finshOjbForm.id = row.id;
    },
    finshOjb() {
      service.$ajaxFinishOnJob(this.deleteNullRelation(this.finshOjbForm)).then(res => {
        this.showFinshOjb = false;
        this.queryList();
        this.$forceUpdate();
      });
    },
    cancelOnjob(row) {
      this.$confirm("确认取消跟单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        service.$ajaxCancelOnJob({ onJobId: row.id }).then(res => {
          this.queryList();
          this.$forceUpdate();
        });
      });
    },
    getWorkerNameList(workerNo) {
      service.$ajaxgetWorkerNameList({ workerNo: workerNo }).then(res => {
        this.workerNameList = res.data.data;
      });
    },
    addHmTradeNos(e, row) {
      if (this.subAddForm.hmTradeNos.length >= this.maxSubLength) {
        this.$message.error("超过可跟单最大数量");
        return;
      }
      let obj = row;
      obj.hmTradeNo = row.bookTradeNo;
      this.subAddForm.hmTradeNos.push(obj);
      //禁用按钮
      this.$set(this.tradeOrderList[e.$index], "isEdit", true);
      this.$forceUpdate();
      this.updateContent(obj.position);

    },
    //改标记样式
    updateContent: function (position) {
      let markers = this.markers;
      if (!markers) {
        return;
      }
      for (let i = 0; i < markers.length; i++) {
        let positions = position.split(",");
        let lng = "";
        let lat = "";
        if (markers[i].getPosition().lat == undefined && markers[i].getPosition().lng == undefined) {
          lng = markers[i].getPosition().split(",")[0];
          lat = markers[i].getPosition().split(",")[1];
        } else {
          lat = markers[i].getPosition().lat;
          lng = markers[i].getPosition().lng;
        }
        if (positions[0] == lng && positions[1] == lat) {
          // 自定义点标记内容
          var markerContent = document.createElement("div");

          // 点标记中的图标
          var markerImg = document.createElement("img");
          markerImg.className = "markerlnglat";
          markerImg.src = "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png";
          markerImg.setAttribute("width", "25px");
          markerImg.setAttribute("height", "34px");
          markerContent.appendChild(markerImg);

          this.removeMarker.push(markers[i]);
          markers[i].setContent(markerContent); //更新点标记内容
          markers[i].setPosition(position); //更新点标记位置
        }
      }
    },
    //恢复标记样式
    defaultMarker(position) {
      let markers = this.removeMarker;
      if (!markers) {
        return;
      }
      for (let i = 0; i < markers.length; i++) {
        let positions = position.split(",");
        let lat = markers[i].getPosition().split(",")[0];
        let lng = markers[i].getPosition().split(",")[1];
        if (positions[0] == lat && positions[1] == lng) {
          console.log(1);
          // 自定义点标记内容
          var markerContent = document.createElement("div");

          // 点标记中的图标
          var markerImg = document.createElement("img");
          markerImg.className = "markerlnglat";
          markerImg.src = "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png";
          markerImg.setAttribute("width", "25px");
          markerImg.setAttribute("height", "34px");
          markerContent.appendChild(markerImg);

          markers[i].setContent(markerContent); //更新点标记内容
          markers[i].setPosition(position); //更新点标记位置

        }
      }

    }
  }


}
  ;
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}

#mapWrapper {
  height: 460px;
  width: 100%;
  margin-bottom: 20px;
}

.order-form .el-input--small.el-input {
  width: 120px;
}
</style>
